export const DELIVERY_METHODS = [
  { id: "ug_free", label: "Free Delivery — Kampala & Entebbe", fee: 0, country: "UG", hint: "Kampala & Entebbe town only" },
  { id: "ug_upcountry", label: "Upcountry Uganda Delivery", fee: 10, country: "UG", hint: "Other Uganda districts — flat $10 (≈ USh 38,000)" },
  { id: "pickup", label: "Store Pickup — Downtown Entebbe", fee: 0, country: "", hint: "Collect from our Entebbe office" },
  { id: "mn_free", label: "Free Delivery — Minnesota, USA", fee: 0, country: "US", hint: "Minnesota addresses only" },
  { id: "ship", label: "Standard Shipping — USA & Canada", fee: 25, country: "", hint: "Flat $25 per order, rest of USA & Canada" },
]

export const COUNTRIES = [["UG", "Uganda"], ["US", "United States"], ["CA", "Canada"]]

const isMN = (r) => ["mn", "minnesota"].includes((r || "").trim().toLowerCase())

export function deliveryError(d) {
  if (!d.method) return "Choose a delivery method."
  if (d.full_name.trim().length < 2 || d.phone.trim().length < 7) return "Enter your full name and phone number."
  if (d.method === "pickup") return ""
  if (!d.address.trim() || !d.city.trim() || !d.country) return "Enter your street address, city and country."
  const city = d.city.trim().toLowerCase()
  if (d.method === "ug_free" && (d.country !== "UG" || !["kampala", "entebbe"].includes(city))) return "Free Uganda delivery covers Kampala and Entebbe only — choose Upcountry Delivery or Store Pickup."
  if (d.method === "ug_upcountry" && d.country !== "UG") return "Upcountry delivery is for Uganda addresses."
  if (d.method === "mn_free" && (d.country !== "US" || !isMN(d.region))) return "Free US delivery is for Minnesota addresses only — choose Standard Shipping."
  if (d.method === "ship" && !((d.country === "US" && !isMN(d.region)) || d.country === "CA")) return d.country === "US" ? "Minnesota addresses get free delivery — choose Free Delivery — Minnesota." : "Standard Shipping covers the USA and Canada."
  if (["mn_free", "ship"].includes(d.method) && (!d.region.trim() || !d.postal_code.trim())) return "Enter your state/province and ZIP/postal code."
  return ""
}

export const deliveryFee = (method) => DELIVERY_METHODS.find((m) => m.id === method)?.fee || 0
